import { all } from "redux-saga/effects";
import { tongHopHocPhi } from "./tongHopHocPhiSaga";

export default function* tongHopSagaWrapper() {
  yield all([tongHopHocPhi()]);
}
